import React from 'react'

import { Clickable, isBrowser, Select } from 'chemistry'
import { properProductCode } from 'common/utils'

const getProductCodeFromUrl = url => url.split('/').pop()

export const ProductVariants = ({ product }) => {
  const areNewVariantsAvailable = product.variants?.length > 0
  const variants = areNewVariantsAvailable ? product.variants : product.flatVariantOptions
  const currentProductCode = areNewVariantsAvailable ? properProductCode(product.code) : product.code
  const onSelect = url => {
    if (isBrowser()) {
      window?.pageBus?.dispatch({
        type: 'PRODUCT_VARIANT_CHANGED',
        url
      })
      window?.pageBus?.dispatch({
        type: 'SELECT_VARIANT',
        variants,
        selectedProductCode: getProductCodeFromUrl(url),
        currentProductCode
      })
      window.location.href = url.replace('//', '/')
    }
  }

  if (!variants?.length) return null

  const allDropdownsOptionsDisabled = variants.every(variant =>
    variant.entries.every(entry => entry.product.code === currentProductCode || !entry?.validVariant)
  )
  if (allDropdownsOptionsDisabled) return null

  if (variants.length === 1 && variants[0].entries?.length <= 3) {
    return <VariantClickable variant={variants[0]} onSelect={onSelect} currentProductCode={currentProductCode} />
  }

  return (
    <div className='flex gap-1'>
      {variants.map(variant => {
        return (
          <VariantSelect
            key={variant.code}
            onSelect={onSelect}
            variant={variant}
            currentProductCode={currentProductCode}
          />
        )
      })}
    </div>
  )
}

const VariantClickable = ({ variant, onSelect, currentProductCode }) => {
  const { code, entries, name } = variant || {}
  return (
    <Clickable
      code={properProductCode(code)}
      entries={entries}
      name={name}
      current={currentProductCode}
      onClick={onSelect}
    />
  )
}

const VariantSelect = ({ variant, onSelect, currentProductCode }) => {
  const currentVariantEntry = variant.entries.find(entry => entry.product.code === currentProductCode)
  if (!currentVariantEntry) return null

  const selectedValue = currentVariantEntry.product.url

  const options = []
  for (const entry of variant.entries) {
    const { name, validVariant, product: { url } = {} } = entry || {}
    const alreadyExistingOptionIndex = options.findIndex(option => option.label === name)
    const option = {
      value: url,
      label: name
    }
    if (alreadyExistingOptionIndex < 0) {
      if (!validVariant) option.disabled = 'disabled'
      options.push(option)
    } else if (options[alreadyExistingOptionIndex].disabled && validVariant) {
      options[alreadyExistingOptionIndex] = option
    }
  }

  const currentOptionIndex = options.findIndex(({ label }) => label === currentVariantEntry.name)
  const optionsExceptCurrent = [...options.slice(0, currentOptionIndex), ...options.slice(currentOptionIndex + 1)]

  optionsExceptCurrent.sort((a, b) => {
    if (a.label < b.label) {
      return -1
    }
    if (a.label > b.label) {
      return 1
    }
    return 0
  })

  const currentOption = options[currentOptionIndex]
  const optionsSorted = [currentOption, ...optionsExceptCurrent]
  return (
    <Select
      options={optionsSorted}
      className='mxd-select'
      value={selectedValue}
      label={variant.name}
      onChange={e => onSelect(e?.target?.value)}
    />
  )
}
